import { all, put, takeLatest } from 'redux-saga/effects';
import { messagesRequest } from 'modules/messages/actions';
import i18n from 'i18n';
import endpoints, { api } from './endpoints';
import {
  getUserTrustedDevicesRequest,
  getUserTrustedDevicesFulfilled,
  getUserTrustedDevicesRejected,
  deleteTrustedDeviceRequest,
  deleteTrustedDeviceFulfilled,
  deleteTrustedDeviceRejected,
} from './actions';

function* getUserTrustedDevicesRequestSaga({ payload }) {
  const { userUuid, query } = payload;

  try {
    const { data } = yield api.get({
      url: endpoints.getUserTrustedDevices(userUuid, query),
    });

    return yield put(getUserTrustedDevicesFulfilled(data));
  } catch (error) {
    return yield put(getUserTrustedDevicesRejected());
  }
}

function* deleteTrustedDeviceRequestSaga({ payload }) {
  const { userUuid, devices, query } = payload;

  try {
    yield api.patch({
      url: endpoints.deleteTrustedDevices(userUuid),
      data: {
        devices,
      },
    });

    yield put(deleteTrustedDeviceFulfilled());

    yield put(
      messagesRequest({
        message: i18n.t('TRUSTED_DEVICE_DELETED_SUCCESSFULLY_KEY'),
        type: 'success',
      })
    );

    yield put(
      getUserTrustedDevicesRequest({
        userUuid: payload.userUuid,
        query,
      })
    );
  } catch (error) {
    yield put(deleteTrustedDeviceRejected());

    yield put(
      messagesRequest({
        message: i18n.t('ERROR_DELETING_TRUSTED_DEVICE_KEY'),
        type: 'error',
      })
    );
  }
}

export default all([
  takeLatest(getUserTrustedDevicesRequest, getUserTrustedDevicesRequestSaga),
  takeLatest(deleteTrustedDeviceRequest, deleteTrustedDeviceRequestSaga),
]);
